export default __webpack_public_path__ + "static/media/jtriley-colored.305cb506.webp";